// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__1JaVC","addWidgetButton":"Header_addWidgetButton__3XAaA","dashboardTabs":"Header_dashboardTabs__2bK56","active":"Header_active__17gdH"};